import { UrlObject } from "url";
import { convertUrlObjectToString, getBaseDomain } from "~/lib/utils/urlHelper";

function encodeUrlObject(url: UrlObject, locale?: string): string {
  return encodeURIComponent(
    convertUrlObjectToString({
      locale,
      url: { ...url, host: url?.host || getBaseDomain() },
    })
  );
}

export function composeShareUrlLine({
  locale,
  shareText,
  url,
}: {
  locale?: string;
  shareText: string;
  url: UrlObject;
}) {
  const encodedUrl = encodeUrlObject(url, locale);
  return `https://social-plugins.line.me/lineit/share?url=${encodedUrl}&text=${shareText}`;
}

export function composeShareUrlTwitter({
  account: account,
  hashTags = [],
  locale,
  shareText,
  url,
}: {
  account?: string;
  shareText: string;
  hashTags?: string[];
  locale?: string;
  url: UrlObject;
}) {
  const encodedUrl = encodeUrlObject(url, locale);
  return `https://twitter.com/intent/tweet?text=${encodeURIComponent(
    joinTextWithHashTags(shareText, hashTags)
  )}&url=${encodedUrl}${account ? `&via=${account}` : ""}`;
}

// Twitter basically allows posts with up to 140 characters (in Japanese).
// When adding a URL, it seems to be counted as 11 chars no matter the real length.
// So, I decided to limit the max length of shareText at 120 (with some extra margin).
const TWITTER_SHARE_TEXT_MAX_LENGTH = 120 as const;

export function joinTextWithHashTags(
  text: string,
  hashTags: string[] | undefined
): string {
  const joinedTagsStr = hashTags
    ? hashTags.map((t) => (t.startsWith("#") ? t : `#${t}`)).join(" ")
    : "";
  const rawJoinedResult = `${text} ${joinedTagsStr}`;
  const exceedingTextLength =
    rawJoinedResult.length - TWITTER_SHARE_TEXT_MAX_LENGTH;
  if (exceedingTextLength <= 0) {
    return rawJoinedResult;
  }
  return `${text.substring(
    0,
    text.length - exceedingTextLength
  )} ${joinedTagsStr}`;
}

export function composeShareUrlHatena({
  locale,
  url,
}: {
  locale?: string;
  url: UrlObject;
}) {
  const encodedUrl = encodeUrlObject(url, locale);
  return `https://b.hatena.ne.jp/entry/panel/?mode=confirm&url=${encodedUrl}`;
}
